// extracted by mini-css-extract-plugin
export default {"invoiceHeaderBadges":"InvoiceFoo_invoiceHeaderBadges__mudge"};